var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "well",
      attrs: { model: _vm.form, "label-width": "150", "label-position": "left" }
    },
    [
      _c(
        "article",
        [
          _c("h3", { staticClass: "mt-0" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Documents de vente")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Choisissez à partir de quelle étape vous voulez que vos documents de vente soient envoyés automatiquement en compta"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "mb-0",
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "gray-100" }, [
                        _vm._v(_vm._s(_vm.getStepById("invoice").label))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t.__("common.actions.select") },
                  model: {
                    value: _vm.form.autoinvoiceStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "autoinvoiceStatus", $$v)
                    },
                    expression: "form.autoinvoiceStatus"
                  }
                },
                _vm._l(_vm.getStepById("invoice").steps, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "gray-100" }, [
                        _vm._v(_vm._s(_vm.getStepById("creditnote").label))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t.__("common.actions.select") },
                  model: {
                    value: _vm.form.autocreditnoteStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "autocreditnoteStatus", $$v)
                    },
                    expression: "form.autocreditnoteStatus"
                  }
                },
                _vm._l(_vm.getStepById("creditnote").steps, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        [
          _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Documents d'achat")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Choisissez à partir de quelle étape vous voulez que vos documents d'achat soient envoyés automatiquement en compta"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "gray-100" }, [
                        _vm._v(_vm._s(_vm.getStepById("purInvoice").label))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t.__("common.actions.select") },
                  model: {
                    value: _vm.form.autopurinvoiceStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "autopurinvoiceStatus", $$v)
                    },
                    expression: "form.autopurinvoiceStatus"
                  }
                },
                _vm._l(_vm.getStepById("purInvoice").steps, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "gray-100" }, [
                        _vm._v(_vm._s(_vm.getStepById("purCreditNote").label))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t.__("common.actions.select") },
                  model: {
                    value: _vm.form.autopurcreditnoteStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "autopurcreditnoteStatus", $$v)
                    },
                    expression: "form.autopurcreditnoteStatus"
                  }
                },
                _vm._l(_vm.getStepById("purCreditNote").steps, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-level" },
        [
          _c("CompassButton", {
            staticClass: "flex-item-right",
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }